import React, { useRef, useState } from "react";
import { Button, Stack, TextField } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import axiosClient from "../../api/axiosClient";

export default function OwnerAccountsUpload({ propertyId, onMessage, onUploaded }) {
  const fileInputRef = useRef(null);
  const [year, setYear] = useState("");
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const upload = async () => {
    if (!year || !file) return;
    setSubmitting(true);
    try {
      const payload = new FormData();
      payload.append("accounts_year", String(Number(year)));
      payload.append("file", file);
      await axiosClient.post(`/properties/${propertyId}/owner-accounts/`, payload);
      setYear("");
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      onMessage?.("Accounts published for owners.");
      onUploaded?.();
    } catch (err) {
      onMessage?.(err?.response?.data?.error || "Upload failed.", "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ sm: "center" }} sx={{ mb: 2 }}>
      <TextField
        label="Accounts year"
        value={year}
        onChange={(event) => setYear(event.target.value)}
        size="small"
        type="number"
        inputProps={{ min: 1900, max: 2100 }}
      />
      <Button variant="outlined" component="label" startIcon={<UploadFileIcon />}>
        {file ? file.name : "Choose file"}
        <input
          ref={fileInputRef}
          type="file"
          hidden
          onChange={(event) => setFile(event.target.files?.[0] || null)}
        />
      </Button>
      <Button
        variant="outlined"
        onClick={upload}
        disabled={!year || !file || submitting}
        startIcon={<UploadFileIcon />}
      >
        + Publish accounts
      </Button>
    </Stack>
  );
}
